import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { environment } from "src/environment/environment";

@Component({
  selector: "app-complaints-list",
  templateUrl: "./complaints-list.component.html",
  styleUrls: ["./complaints-list.component.css"],
})
export class ComplaintsListComponent implements OnInit {
  employeeList = [];
  complaintLists: any = [];
  id: any;
  customer_id: any;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective, { static: false }) datatableElement:
    | DataTableDirective
    | undefined;

  project_no: any;
  customerName: any;
  priceValidityTill: any;
  serviceCallData: boolean = false;

  constructor(private router: Router, private http: HttpClient) {}

  ngOnInit() {
    // Redirect if customerId is missing in localStorage
    if (!localStorage.getItem("customerId")) {
      this.router.navigate(["/login"]);
      return;
    }
    this.customer_id = localStorage.getItem("customerId");
    this.initializeDataTable();
  }

  initializeDataTable() {
    this.dtOptions = {
      paging: true,
      retrieve: true,
      ordering: true,
      // processing: true,
      serverSide: true,
      searching: true,
      responsive: true,
      pagingType: "full_numbers",
      pageLength: 10, // Number of rows per page
      lengthMenu: [5, 10, 25, 50, 75, 100],
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search in table",
      },
      order: [[4, "desc"]],
      createdRow: (row: Node, data: any[] | Object, index: number) => {
        // Cast the row to HTMLElement before using querySelectorAll
        const tds = (row as HTMLElement).querySelectorAll("td");
        tds.forEach((td) => {
          td.style.fontSize = "12px"; // Set inline font size for each cell
        });
      },
      ajax: (dataTablesParameters: any, callback) => {
        const currentPage =
          Math.floor(dataTablesParameters.start / dataTablesParameters.length) +
          1;
        const orderColumnIndex = dataTablesParameters.order?.[0]?.column;
        const orderDirection = dataTablesParameters.order?.[0]?.dir || "desc";
        const searchValue = dataTablesParameters.search?.value || "";
        const columnName =
          dataTablesParameters.columns[orderColumnIndex]?.data || "id";

        const requestData = {
          modelName: "employee_tasks",
          whereCondition: {
            customer_name: this.customer_id,
            issue_category:9 // External Customer Complaint - new
            // user_type: 2, //old
          },
          pagination: {
            page: currentPage,
            pageSize: dataTablesParameters.length,
          },
          search: {
            searchKeyword: searchValue,
            field_name: [
                "email",
                // "created_at",
                "subject",
                "department.name",
                "employee_master.first_name",
                "employee_master.last_name",
                "product_category_masters.product_category",
                "task_number",
                "created_at",
                "employee_task_statuses.status_name"
            ]
          },
          orderByModelWise: { field: columnName, order: orderDirection },
          orderByColumnNumber: orderColumnIndex,
          relations: [
            {
              module: "department",
              moduleAs: "department",
            },
            {
              module: "product_category_masters",
              moduleAs: "product_category_masters",
            },
            {
              module: "employee_master",
              moduleAs: "employee_master",
            },
            {
              "module": "employee_task_statuses",
              "moduleAs": "employee_task_statuses"
            }
          ],
        };
        this.http
          .post<any>(`${environment.url}/common/getRecords`, requestData)
          .subscribe(
            (resp: any) => {
              this.serviceCallData = true;
              this.complaintLists = resp.data;
              callback({
                recordsTotal: resp.count,
                recordsFiltered: resp.count,
                data: this.complaintLists || [],
              });
              this.dtTrigger.next(null);
            },
            (error) => {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
            }
          );
      },
      columns: [
        {
          data: null,
          title: "Sr.No.",
          render: (data: any, type: any, row: any, meta: any) => {
            // return meta.row + 1; // Display the row index starting from 1
            const pageSize = this.dtOptions?.pageLength || 10; // Default to 10 if undefined
            const currentPage = Math.floor(meta.settings._iDisplayStart / pageSize) + 1;
            return pageSize * (currentPage - 1) + (meta.row + 1);
          },
        },
        {
          data: 'task_number',
          title: "Task Number",
          render: (data: any) => {
            return data ? data : "-"; // Display "-" if data is null or undefined
          },
        },
        {
          data: "department.name",
          title: "SO Number (Project Name)",
          render: (data: any) => {
            return data ? data : "-"; // Display "-" if data is null or undefined
          },
        },
        {
          data: "email",
          title: "E-Mail",
          render: (data: any) => {
            return data ? data : "-"; // Display "-" if data is null or undefined
          },
        },
        {
          data: "created_at",
          title: "Complaint Date",
          render: (data: any) => {
            return data
              ? new Date(data).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  timeZone: "UTC" // This ensures it doesn't shift to local date - added because task - T250108 created date in api response was "2025-04-15T19:14:27.000Z" but in UI it was showing 16/04/2025
                })
              : "-";
          },
        },
        {
          data: "product_category_masters.product_category",
          title: "Machine Type",
          render: (data: any) => {
            return data ? data : "-";
          },
        },
        {
          data: "subject",
          title: "Subject",
          render: (data: any) => {
            return data ? data : "-";
          },
        },
        {
          data: "employee_master.first_name", // Reference a valid field
          title: "Last Updated By",
          render: (data: any, type: any, row: any) => {
            return row.employee_master?.first_name && row.employee_master?.last_name
              ? `${row.employee_master.first_name} ${row.employee_master.last_name}`
              : "-";
          },
        },
        {
          data: "employee_task_statuses.status_name",
          title: "Status",
          render: (data: any, type: any, row: any) => {
            //Rajesh - will remove in next commit
            // return (
            //   (() => {
            //     switch (row.status) {
            //       case 1:
            //         return "Open";
            //       case 2:
            //         return "WIP";
            //       case 3:
            //         return "Completed";
            //       case 4:
            //         return "Cancelled";
            //       case 7:
            //         return "Rejected";
            //       case 15:
            //         return "Closed";
            //       default:
            //         return "Unknown";
            //     }
            //   })() || "-"
            // );

            return row.employee_task_statuses?.status_name && row.employee_task_statuses?.status_name
            ? `${row.employee_task_statuses.status_name}`
            : "-";
          },
        },
        {
          data: null,
          title: "Action",
          render: (data: any) => {
            return `
              <i class="fa fa-eye view-icon" data-id="${data.id}" style="cursor: pointer; color: #007bff;"></i>
            `;
          },
        },
      ],
      columnDefs: [{ targets: [9], orderable: false }],
    };
  }

  onAdd() {
    let action = "Add";
    this.router.navigate(["/ComplaintsCreate/", action]);
  }

  onView(id: any) {
    console.log("clicked on button");
    this.router.navigate(["/ComplaintsView/", id]);
  }

  ngAfterViewInit(): void {
    if (this.datatableElement) {
      this.dtTrigger.next(null);

      // Attach event listener for dynamically generated icons
      $(document).on("click", ".view-icon", (event: any) => {
        const id = $(event.target).data("id");
        this.onView(id);
      });
    } else {
      console.error("DataTableDirective not found.");
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe(); // Clean up DataTable trigger
  }
}